//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Toggleable from '../../mixins/toggleable'

export default {
  name: 'pagination',

  mixins: [Toggleable],

  props: {
    circle: Boolean,

    disabled: Boolean,

    length: {
      type: Number,
      default: 0
    },

    value: {
      type: Number,
      default: 0
    }
  },

  watch: {
    value () {
      this.init()
    }
  },

  computed: {
    classes () {
      return {
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      }
    },

    items () {
      if (this.length <= 5) {
        return this.range(1, this.length)
      }

      let min = this.value - 3
      min = min > 0 ? min : 1

      let max = min + 6
      max = max <= this.length ? max : this.length

      if (max === this.length) {
        min = this.length - 6
      }

      const range = this.range(min, max)

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...')
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length)
      }

      return range
    }
  },

  mounted () {
    this.$vuetify.load.call(this, this.init)
  },

  methods: {
    init () {
      this.selected = null

      // Change this
      setTimeout(() => (this.selected = this.value), 100)
    },

    range (from, to) {
      const range = []

      from = from > 0 ? from : 1

      for (let i = from; i <= to; i++) {
        range.push(i)
      }

      return range
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/pagination/Pagination.vue